import { geoToGeoFormModel, geoFormModelToGeo } from '../../../geo/components/form-geo-field/mappers';
import { HRInterview, JobApplication } from '../../../providers/api/dtos';
import { boolToBooleanString, booleanStringToBool } from '../../../utils/boolean-string/booleanString';
import { formatInputDate, formatInputTime, formDateTimeToDate } from '../../../utils/form';
import { HRInterviewFormModel } from './types';

export const hrInterviewToHRInterviewFormModel = (
  jobApplication: JobApplication,
  hrInterview?: HRInterview,
  fallback?: Pick<HRInterviewFormModel, 'supervisorEmail' | 'assigneeEmail'>,
): Partial<HRInterviewFormModel> => ({
  supervisorEmail: jobApplication.supervisorEmail || fallback?.supervisorEmail,
  assigneeEmail: jobApplication.assigneeEmail || fallback?.assigneeEmail,
  date: hrInterview?.date ? formatInputDate(new Date(hrInterview.date)) : '',
  time: hrInterview?.date ? formatInputTime(new Date(hrInterview.date)) : '',
  note: hrInterview?.note,
  interviewerEmail: hrInterview?.interviewerEmail,
  extraParticipantEmail: hrInterview?.extraParticipantEmail,
  isRemote: boolToBooleanString(hrInterview?.isRemote),
  address: geoToGeoFormModel(hrInterview?.address),
  ...(jobApplication.applicationType === 'SALES' && { isFranchising: boolToBooleanString(jobApplication.isFranchising) }),
});

export const hrInterviewFormModelToHRInterview = (
  formValues: HRInterviewFormModel,
  jobApplication: JobApplication,
  hrInterview?: HRInterview,
): HRInterview => ({
  ...hrInterview,
  status: hrInterview?.status ?? 'TODO',
  type: hrInterview?.type ?? 'INTERVIEW',
  jobApplicationId: jobApplication.id!,
  date: formDateTimeToDate(formValues.date, formValues.time).toISOString(),
  isRemote: booleanStringToBool(formValues.isRemote),
  address: formValues.address ? geoFormModelToGeo(formValues.address) : undefined,
  note: formValues.note?.trim() || undefined,
  interviewerEmail: formValues.interviewerEmail?.trim(),
  extraParticipantEmail: formValues.extraParticipantEmail?.trim() || undefined,
});
